module.exports = __webpack_public_path__ + "static/media/zachary-EcoBux-Profile.c1276cbb.png";